import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { auth as tokenStore, hasValidAccessToken } from '../../api/axios';

interface Props {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<Props> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  const tokenOk = hasValidAccessToken();
  if (!tokenOk && tokenStore.getAccessToken()) {
    tokenStore.clear();
  }

  if (loading && tokenOk) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Chargement…
      </div>
    );
  }

  if (!user && !tokenOk) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (user && user.role !== 'PLATFORM_ADMIN') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default AdminProtectedRoute;
